import React, { useState, useEffect } from "react";
import InputDoctorAndPatient from "../../otc_transaction/component/inputDoctorAndPatient";
import InputPrescriptionTransaction from "../../otc_transaction/component/inputPrescriptionTransaction";
import PaymentMethodOtcTransaction from "../../otc_transaction/component/paymentMethodOtcTransaction";
import TotalOtcPayment from "../../otc_transaction/component/totalOtcPayment";
import { Constant } from "../../../../helper/constant";
import { useNavigate } from "react-router-dom";
import { getIndonesianISOString } from "../../../../helper/formatDate";

const PartnerOtcTransaction = () => {
  // =====================
  // Constant Definition
  // =====================
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [doctorData, setDoctorData] = useState({
    doctor_id: "",
    doctor_name: "",
  });
  const [patientData, setPatientData] = useState({
    patient_id: "",
    patient_name: "",
  });
  const [prescriptionTransactionData, setPrescriptionTransactionData] =
    useState([
      {
        product_id: "",
        product_name: "",
        product_quantity: "",
        product_display_price: "Rp 0",
        product_amount: 0,
        product_total_price: 0,
        product_buying_price: 0,
        is_prescription: true,
      },
    ]);
  const listPayment = ["REKANAN"];
  const listRemainingPaymentOption = [
    "TIDAK ADA",
    "CASH",
    "TRANSFER",
    "DEBIT",
    "QRIS",
    "KARTU KREDIT",
  ];
  const listCourier = ["TIDAK ADA", "INTERNAL", "GOJEK", "GRAB"];
  const [courierData, setCourierData] = useState("TIDAK ADA");
  const [courierFee, setCourierFee] = useState(0);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState("REKANAN");
  const [remainingPaymentOption, setSelectedRemainingPaymentOption] =
    useState("TIDAK ADA");
  const [bankData, setBankData] = useState([""]);
  const [selectedBankOption, setSelectedBankOption] = useState("");
  const [buyerCashTransaction, setBuyerCashTransaction] = useState(0);
  const [totalTransaction, setTotalTransaction] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [partnerData, setParnerData] = useState({
    partner_id: "",
    partner_name: "",
  });
  const [insuranceCovered, setInsuranceCovered] = useState(0);

  const isProductRowEmpty = (product) => {
    return product.product_id === "" && product.product_quantity === ""
  }

  const isProductRowComplete = (product) => {
    return product.product_id !== "" && product.product_quantity !== ""
  }

  const validateProducts = (products) => {
    return products.every((product) => {
      if (isProductRowEmpty(product)) return true
      if (isProductRowComplete(product)) return true
      // product-row not complete
      return false
    })
  }

  const validateProductsComplete = (products) => {
    return products.some((item) => isProductRowComplete(item))
  }

  // =====================
  // Method Definition
  // =====================

  const onConfirmCliked = () => {
    confirmTransaction();
  };

  // =====================
  // Network Request Definition
  // =====================

  const confirmTransaction = async () => {
    const isAvailablePrescriptionProducts = validateProducts(prescriptionTransactionData)
    if (!isAvailablePrescriptionProducts) {
      alert("Ada produk yg tidak tersedia. Silahkan cek ulang, pastikan produk tersedia dan terisi dengan benar")
      return
    }

    const hasPrescriptionProducts = validateProductsComplete(prescriptionTransactionData)
    if (!hasPrescriptionProducts) {
      alert("Produk atau resep harus diisi")
      return
    }

    try {
      setIsLoading(true);
      const staffData = localStorage.getItem("user_data");
      const parsedStaffData = JSON.parse(staffData);

      const formatTransactionData = (data) =>
        data.map((product) => ({
          product_transaction_id: product.product_id,
          product_transaction_name: product.product_name,
          product_transaction_quantity: Number(product.product_quantity),
          product_transaction_per_item_price: Number(product.product_amount),
          product_transaction_price: product.product_total_price,
          product_transaction_profit:
            Number(product.product_total_price) -
            Number(product.product_buying_price) *
            Number(product.product_quantity),
          is_prescription: product.is_prescription,
        }));

      const combinedData = [
        ...formatTransactionData(prescriptionTransactionData),
      ].filter((product) => product.product_transaction_id);

      let url = Constant.BASE_API_URL + "/produk-transaksi";
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({
          product_transaction_date: getIndonesianISOString(),
          staff_id: parsedStaffData.staff_id,
          staff_name: parsedStaffData.staff_name,
          staff_shift: Number(localStorage.getItem("staff_shift")),
          doctor_id: doctorData.doctor_id,
          doctor_name: doctorData.doctor_name,
          patient_id: patientData.patient_id,
          patient_name: patientData.patient_name,
          product_transaction_data: combinedData,
          partner_id: partnerData.partner_id,
          partner_name: partnerData.partner_name,
          courier_name: courierData,
          courier_fee: courierFee,
          payment_bank_id:
            selectedPaymentOption !== "TRANSFER"
              ? ""
              : selectedBankOption.bank_id,
          payment_bank_name:
            selectedPaymentOption !== "TRANSFER"
              ? ""
              : selectedBankOption.bank_name,
          payment_method:
            selectedPaymentOption === "REKANAN"
              ? remainingPaymentOption
              : selectedPaymentOption,
          cash_transaction: buyerCashTransaction,
          total_transaction: totalTransaction,
          total_payment: totalPayment,
          total_insurance_covered: insuranceCovered,
        }),
      });
      if (!response.ok) {
        alert("Gagal Membuat Transaksi Baru");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      } else {
        setIsLoading(false);
        navigate("/apotek-penjualan-perhari");
      }
    } catch (error) {
      alert("Gagal Membuat Transaksi Baru");
      setIsLoading(false);
    }
  };

  // =====================
  // Hooks Definition
  // =====================

  useEffect(() => {
    const roundToNearest100 = (value) => {
      return Math.ceil(value / 100) * 100;
    };

    var totalAmount = 0;
    var totalPayment = 0;

    prescriptionTransactionData.forEach((prescription) => {
      totalAmount += prescription.product_total_price;
    });

    var roundedTotalAmount = roundToNearest100(totalAmount);
    roundedTotalAmount += courierFee;

    totalPayment = roundedTotalAmount;

    setTotalTransaction(roundedTotalAmount);
    if (
      selectedPaymentOption === "REKANAN" &&
      roundedTotalAmount - insuranceCovered >= 0 &&
      partnerData.partner_id !== ""
    ) {
      totalPayment -= insuranceCovered;
    }
    setTotalPayment(totalPayment);
  }, [
    prescriptionTransactionData,
    courierFee,
    selectedPaymentOption,
    insuranceCovered,
    partnerData,
  ]);

  // =====================
  // Layout
  // =====================
  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Kasir Apotek Rekanan</h1>
      <InputDoctorAndPatient
        doctorData={doctorData}
        setDoctorData={setDoctorData}
        patientData={patientData}
        setPatientData={setPatientData}
      />
      <InputPrescriptionTransaction
        prescriptionTransactionData={prescriptionTransactionData}
        setPrescriptionTransactionData={setPrescriptionTransactionData}
        isPartnerPrescription={true}
      />
      <PaymentMethodOtcTransaction
        listPayment={listPayment}
        selectedPaymentOption={selectedPaymentOption}
        setSelectedPaymentOption={setSelectedPaymentOption}
        listBank={bankData}
        selectedBankOption={selectedBankOption}
        setSelectedBankOption={setSelectedBankOption}
        buyerCash={buyerCashTransaction}
        setBuyerCash={setBuyerCashTransaction}
        totalTransaction={totalTransaction}
        setPartnerData={setParnerData}
        partnerData={partnerData}
        listCourier={listCourier}
        setCourierData={setCourierData}
        courierFee={courierFee}
        setCourierFee={setCourierFee}
        showCourierFeeSection={true}
        insuranceCovered={insuranceCovered}
        setInsuranceCovered={setInsuranceCovered}
        listRemainingPaymentOption={listRemainingPaymentOption}
        remainingPaymentOption={remainingPaymentOption}
        setSelectedRemainingPaymentOption={setSelectedRemainingPaymentOption}
      />
      <TotalOtcPayment
        totalAmount={totalPayment}
        onConfirmCliked={onConfirmCliked}
      />
    </div>
  );
};

export default PartnerOtcTransaction;
